/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceAppendixType = exports.SegmentSegment = exports.RuleType = exports.Role = exports.ResolutionStatus = exports.QueryParticipantsRequestSortingOrder = exports.QueryParticipantsRequestSortingCriterion = exports.PrivacyStatusStatus = exports.PaymentType = exports.ParticipationState = exports.ParticipantTransitionState = exports.ParticipantStepUpdateStatus = exports.ParticipantStepTransitionState = exports.ParticipantStepState = exports.ParticipantState = exports.PagingType = exports.OptimizeMode = exports.Operator = exports.NullValue = exports.Method = exports.MessageAppendixType = exports.MemberRole = exports.Maturity = exports.ListParticipantsRequestSortingOrder = exports.ListParticipantsRequestSortingCriterion = exports.ListChallengesRequestSortingCriterion = exports.Label = exports.JSType = exports.Initiator = exports.Format = exports.FieldType = exports.FieldDescriptorProtoType = exports.Exposure = exports.EventEventType = exports.DbMethod = exports.ContainerType = exports.ChoiceRightness = exports.ChallengeType = exports.ChallengeRefType = exports.ChallengePricingSinglePaymentPaymentMethod = exports.ChallengeMemberV1Status = exports.ChallengeMemberStatus = exports.CallbackEventType = exports.CType = exports.BulkActionType = exports.ApprovalResolutionStatus = exports.ApprovalRequestType = exports.ApprovalRequestResolutionStatus = exports.ActivityStatusStatus = exports.AccessStatusStatus = void 0;
exports.WinCriterion = exports.ValidationStrategy = exports.V1DurationUnit = exports.V1ChallengeState = exports.V1AccessType = exports.V0DurationUnit = exports.V0ChallengeState = exports.V0AccessType = exports.UserRole = exports.Trigger = exports.TranslatableType = exports.SubjectType = exports.Sort = exports.SiteMemberStatus = exports.SiteMemberPrivacyStatus = exports.SettingsPricingSinglePaymentPaymentMethod = void 0;
var AccessStatusStatus;
(function (AccessStatusStatus) {
    AccessStatusStatus["UNKNOWN"] = "UNKNOWN";
    AccessStatusStatus["PENDING"] = "PENDING";
    AccessStatusStatus["APPROVED"] = "APPROVED";
    AccessStatusStatus["BLOCKED"] = "BLOCKED";
    AccessStatusStatus["OFFLINE"] = "OFFLINE";
})(AccessStatusStatus = exports.AccessStatusStatus || (exports.AccessStatusStatus = {}));
var ActivityStatusStatus;
(function (ActivityStatusStatus) {
    ActivityStatusStatus["UNKNOWN"] = "UNKNOWN";
    ActivityStatusStatus["ACTIVE"] = "ACTIVE";
    ActivityStatusStatus["MUTED"] = "MUTED";
})(ActivityStatusStatus = exports.ActivityStatusStatus || (exports.ActivityStatusStatus = {}));
var ApprovalRequestResolutionStatus;
(function (ApprovalRequestResolutionStatus) {
    ApprovalRequestResolutionStatus["ACCEPTED"] = "ACCEPTED";
    ApprovalRequestResolutionStatus["REJECTED"] = "REJECTED";
    ApprovalRequestResolutionStatus["CANCELLED"] = "CANCELLED";
})(ApprovalRequestResolutionStatus = exports.ApprovalRequestResolutionStatus || (exports.ApprovalRequestResolutionStatus = {}));
var ApprovalRequestType;
(function (ApprovalRequestType) {
    ApprovalRequestType["JOIN_REQUEST"] = "JOIN_REQUEST";
    ApprovalRequestType["INVITATION"] = "INVITATION";
    ApprovalRequestType["STEP_CONFIRMATION"] = "STEP_CONFIRMATION";
})(ApprovalRequestType = exports.ApprovalRequestType || (exports.ApprovalRequestType = {}));
var ApprovalResolutionStatus;
(function (ApprovalResolutionStatus) {
    ApprovalResolutionStatus["Accepted"] = "Accepted";
    ApprovalResolutionStatus["Rejected"] = "Rejected";
    ApprovalResolutionStatus["Recalled"] = "Recalled";
    ApprovalResolutionStatus["Cancelled"] = "Cancelled";
})(ApprovalResolutionStatus = exports.ApprovalResolutionStatus || (exports.ApprovalResolutionStatus = {}));
var BulkActionType;
(function (BulkActionType) {
    BulkActionType["UNKNOWN_ACTION_TYPE"] = "UNKNOWN_ACTION_TYPE";
    BulkActionType["INSERT"] = "INSERT";
    BulkActionType["UPDATE"] = "UPDATE";
    BulkActionType["DELETE"] = "DELETE";
})(BulkActionType = exports.BulkActionType || (exports.BulkActionType = {}));
var CType;
(function (CType) {
    CType["STRING"] = "STRING";
    CType["CORD"] = "CORD";
    CType["STRING_PIECE"] = "STRING_PIECE";
})(CType = exports.CType || (exports.CType = {}));
var CallbackEventType;
(function (CallbackEventType) {
    CallbackEventType["UNKNOWN"] = "UNKNOWN";
    CallbackEventType["CREATED"] = "CREATED";
    CallbackEventType["UPDATED"] = "UPDATED";
    CallbackEventType["DELETED"] = "DELETED";
    CallbackEventType["ACTION"] = "ACTION";
})(CallbackEventType = exports.CallbackEventType || (exports.CallbackEventType = {}));
var ChallengeMemberStatus;
(function (ChallengeMemberStatus) {
    ChallengeMemberStatus["INACTIVE"] = "INACTIVE";
    ChallengeMemberStatus["PARTICIPANT"] = "PARTICIPANT";
    ChallengeMemberStatus["INVITEE"] = "INVITEE";
    ChallengeMemberStatus["JOIN_REQUESTED"] = "JOIN_REQUESTED";
})(ChallengeMemberStatus = exports.ChallengeMemberStatus || (exports.ChallengeMemberStatus = {}));
var ChallengeMemberV1Status;
(function (ChallengeMemberV1Status) {
    ChallengeMemberV1Status["INACTIVE"] = "INACTIVE";
    ChallengeMemberV1Status["PARTICIPANT"] = "PARTICIPANT";
    ChallengeMemberV1Status["INVITEE"] = "INVITEE";
    ChallengeMemberV1Status["JOIN_REQUESTED"] = "JOIN_REQUESTED";
})(ChallengeMemberV1Status = exports.ChallengeMemberV1Status || (exports.ChallengeMemberV1Status = {}));
var ChallengePricingSinglePaymentPaymentMethod;
(function (ChallengePricingSinglePaymentPaymentMethod) {
    ChallengePricingSinglePaymentPaymentMethod["ONLINE_PAYMENT"] = "ONLINE_PAYMENT";
    ChallengePricingSinglePaymentPaymentMethod["OFFLINE_PAYMENT"] = "OFFLINE_PAYMENT";
})(ChallengePricingSinglePaymentPaymentMethod = exports.ChallengePricingSinglePaymentPaymentMethod || (exports.ChallengePricingSinglePaymentPaymentMethod = {}));
var ChallengeRefType;
(function (ChallengeRefType) {
    ChallengeRefType["ChallengeTemplate"] = "ChallengeTemplate";
    ChallengeRefType["Challenge"] = "Challenge";
})(ChallengeRefType = exports.ChallengeRefType || (exports.ChallengeRefType = {}));
var ChallengeType;
(function (ChallengeType) {
    ChallengeType["Personal"] = "Personal";
    ChallengeType["Team"] = "Team";
    ChallengeType["Competition"] = "Competition";
})(ChallengeType = exports.ChallengeType || (exports.ChallengeType = {}));
var ChoiceRightness;
(function (ChoiceRightness) {
    ChoiceRightness["NEUTRAL"] = "NEUTRAL";
    ChoiceRightness["RIGHT"] = "RIGHT";
    ChoiceRightness["WRONG"] = "WRONG";
})(ChoiceRightness = exports.ChoiceRightness || (exports.ChoiceRightness = {}));
var ContainerType;
(function (ContainerType) {
    ContainerType["Challenge"] = "Challenge";
    ContainerType["ChallengeTemplate"] = "ChallengeTemplate";
    ContainerType["StepTemplate"] = "StepTemplate";
})(ContainerType = exports.ContainerType || (exports.ContainerType = {}));
var DbMethod;
(function (DbMethod) {
    DbMethod["FIND_ONE"] = "FIND_ONE";
    DbMethod["FIND"] = "FIND";
    DbMethod["INSERT"] = "INSERT";
    DbMethod["DELETE"] = "DELETE";
    DbMethod["UPDATE"] = "UPDATE";
})(DbMethod = exports.DbMethod || (exports.DbMethod = {}));
var EventEventType;
(function (EventEventType) {
    EventEventType["Joined"] = "Joined";
    EventEventType["StepCompleted"] = "StepCompleted";
    EventEventType["StepFailed"] = "StepFailed";
    EventEventType["ChallengeCompleted"] = "ChallengeCompleted";
    EventEventType["ChallengeFailed"] = "ChallengeFailed";
})(EventEventType = exports.EventEventType || (exports.EventEventType = {}));
var Exposure;
(function (Exposure) {
    Exposure["PRIVATE"] = "PRIVATE";
    Exposure["INTERNAL"] = "INTERNAL";
    Exposure["PUBLIC"] = "PUBLIC";
})(Exposure = exports.Exposure || (exports.Exposure = {}));
var FieldDescriptorProtoType;
(function (FieldDescriptorProtoType) {
    FieldDescriptorProtoType["TYPE_DOUBLE"] = "TYPE_DOUBLE";
    FieldDescriptorProtoType["TYPE_FLOAT"] = "TYPE_FLOAT";
    FieldDescriptorProtoType["TYPE_INT64"] = "TYPE_INT64";
    FieldDescriptorProtoType["TYPE_UINT64"] = "TYPE_UINT64";
    FieldDescriptorProtoType["TYPE_INT32"] = "TYPE_INT32";
    FieldDescriptorProtoType["TYPE_FIXED64"] = "TYPE_FIXED64";
    FieldDescriptorProtoType["TYPE_FIXED32"] = "TYPE_FIXED32";
    FieldDescriptorProtoType["TYPE_BOOL"] = "TYPE_BOOL";
    FieldDescriptorProtoType["TYPE_STRING"] = "TYPE_STRING";
    FieldDescriptorProtoType["TYPE_GROUP"] = "TYPE_GROUP";
    FieldDescriptorProtoType["TYPE_MESSAGE"] = "TYPE_MESSAGE";
    FieldDescriptorProtoType["TYPE_BYTES"] = "TYPE_BYTES";
    FieldDescriptorProtoType["TYPE_UINT32"] = "TYPE_UINT32";
    FieldDescriptorProtoType["TYPE_ENUM"] = "TYPE_ENUM";
    FieldDescriptorProtoType["TYPE_SFIXED32"] = "TYPE_SFIXED32";
    FieldDescriptorProtoType["TYPE_SFIXED64"] = "TYPE_SFIXED64";
    FieldDescriptorProtoType["TYPE_SINT32"] = "TYPE_SINT32";
    FieldDescriptorProtoType["TYPE_SINT64"] = "TYPE_SINT64";
})(FieldDescriptorProtoType = exports.FieldDescriptorProtoType || (exports.FieldDescriptorProtoType = {}));
var FieldType;
(function (FieldType) {
    FieldType["UNKNOWN"] = "UNKNOWN";
    FieldType["ID"] = "ID";
    FieldType["PAGING"] = "PAGING";
    FieldType["FILTER"] = "FILTER";
})(FieldType = exports.FieldType || (exports.FieldType = {}));
var Format;
(function (Format) {
    Format["EMAIL"] = "EMAIL";
    Format["HOSTNAME"] = "HOSTNAME";
    Format["IPV4"] = "IPV4";
    Format["IPV6"] = "IPV6";
    Format["URI"] = "URI";
    Format["WEB_URL"] = "WEB_URL";
    Format["PHONE"] = "PHONE";
    Format["CREDIT_CARD"] = "CREDIT_CARD";
    Format["GUID"] = "GUID";
    Format["COUNTRY"] = "COUNTRY";
    Format["LANGUAGE"] = "LANGUAGE";
    Format["DECIMAL_VALUE"] = "DECIMAL_VALUE";
    Format["CURRENCY"] = "CURRENCY";
    Format["LANGUAGE_TAG"] = "LANGUAGE_TAG";
    Format["COLOR_HEX"] = "COLOR_HEX";
    Format["LOCAL_DATE"] = "LOCAL_DATE";
    Format["LOCAL_TIME"] = "LOCAL_TIME";
    Format["LOCAL_DATE_TIME"] = "LOCAL_DATE_TIME";
})(Format = exports.Format || (exports.Format = {}));
var Initiator;
(function (Initiator) {
    Initiator["Owner"] = "Owner";
    Initiator["Participant"] = "Participant";
})(Initiator = exports.Initiator || (exports.Initiator = {}));
var JSType;
(function (JSType) {
    JSType["JS_NORMAL"] = "JS_NORMAL";
    JSType["JS_STRING"] = "JS_STRING";
    JSType["JS_NUMBER"] = "JS_NUMBER";
})(JSType = exports.JSType || (exports.JSType = {}));
var Label;
(function (Label) {
    Label["LABEL_OPTIONAL"] = "LABEL_OPTIONAL";
    Label["LABEL_REQUIRED"] = "LABEL_REQUIRED";
    Label["LABEL_REPEATED"] = "LABEL_REPEATED";
})(Label = exports.Label || (exports.Label = {}));
var ListChallengesRequestSortingCriterion;
(function (ListChallengesRequestSortingCriterion) {
    ListChallengesRequestSortingCriterion["DEFAULT"] = "DEFAULT";
    ListChallengesRequestSortingCriterion["ACTIVE_FIRST"] = "ACTIVE_FIRST";
    ListChallengesRequestSortingCriterion["LAST_TRANSITION"] = "LAST_TRANSITION";
    ListChallengesRequestSortingCriterion["CREATION_TIME"] = "CREATION_TIME";
})(ListChallengesRequestSortingCriterion = exports.ListChallengesRequestSortingCriterion || (exports.ListChallengesRequestSortingCriterion = {}));
var ListParticipantsRequestSortingCriterion;
(function (ListParticipantsRequestSortingCriterion) {
    ListParticipantsRequestSortingCriterion["DEFAULT"] = "DEFAULT";
    ListParticipantsRequestSortingCriterion["JOIN_DATE"] = "JOIN_DATE";
    ListParticipantsRequestSortingCriterion["NAME"] = "NAME";
    ListParticipantsRequestSortingCriterion["LAST_EVENT"] = "LAST_EVENT";
    ListParticipantsRequestSortingCriterion["PERFORMANCE"] = "PERFORMANCE";
})(ListParticipantsRequestSortingCriterion = exports.ListParticipantsRequestSortingCriterion || (exports.ListParticipantsRequestSortingCriterion = {}));
var ListParticipantsRequestSortingOrder;
(function (ListParticipantsRequestSortingOrder) {
    ListParticipantsRequestSortingOrder["ORDER_DEFAULT"] = "ORDER_DEFAULT";
    ListParticipantsRequestSortingOrder["ORDER_ASC"] = "ORDER_ASC";
    ListParticipantsRequestSortingOrder["ORDER_DESC"] = "ORDER_DESC";
})(ListParticipantsRequestSortingOrder = exports.ListParticipantsRequestSortingOrder || (exports.ListParticipantsRequestSortingOrder = {}));
var Maturity;
(function (Maturity) {
    Maturity["ALPHA"] = "ALPHA";
    Maturity["BETA"] = "BETA";
    Maturity["IA"] = "IA";
    Maturity["GA"] = "GA";
    Maturity["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
})(Maturity = exports.Maturity || (exports.Maturity = {}));
var MemberRole;
(function (MemberRole) {
    MemberRole["OWNER"] = "OWNER";
    MemberRole["PARTICIPANT"] = "PARTICIPANT";
    MemberRole["VIEWER"] = "VIEWER";
})(MemberRole = exports.MemberRole || (exports.MemberRole = {}));
var MessageAppendixType;
(function (MessageAppendixType) {
    MessageAppendixType["UNKNOWN_APPENDIX_TYPE"] = "UNKNOWN_APPENDIX_TYPE";
    MessageAppendixType["AUTO_VELO"] = "AUTO_VELO";
    MessageAppendixType["DOCS_CONF"] = "DOCS_CONF";
    MessageAppendixType["MULTILINGUAL"] = "MULTILINGUAL";
})(MessageAppendixType = exports.MessageAppendixType || (exports.MessageAppendixType = {}));
var Method;
(function (Method) {
    Method["UNKNOWN_METHOD"] = "UNKNOWN_METHOD";
    Method["CREATE"] = "CREATE";
    Method["GET_ITEM"] = "GET_ITEM";
    Method["UPDATE"] = "UPDATE";
    Method["DELETE"] = "DELETE";
    Method["UPSERT"] = "UPSERT";
    Method["LIST"] = "LIST";
    Method["QUERY"] = "QUERY";
    Method["BULK_CREATE"] = "BULK_CREATE";
    Method["BULK_UPDATE"] = "BULK_UPDATE";
    Method["BULK_UPDATE_BY_FILTER"] = "BULK_UPDATE_BY_FILTER";
    Method["BULK_DELETE"] = "BULK_DELETE";
    Method["BULK_DELETE_BY_FILTER"] = "BULK_DELETE_BY_FILTER";
    Method["BULK_UPSERT"] = "BULK_UPSERT";
    Method["LIST_DELETED"] = "LIST_DELETED";
    Method["GET_DELETED"] = "GET_DELETED";
    Method["RESTORE_FROM_TRASHBIN"] = "RESTORE_FROM_TRASHBIN";
    Method["REMOVE_FROM_TRASHBIN"] = "REMOVE_FROM_TRASHBIN";
})(Method = exports.Method || (exports.Method = {}));
var NullValue;
(function (NullValue) {
    NullValue["NULL_VALUE"] = "NULL_VALUE";
})(NullValue = exports.NullValue || (exports.NullValue = {}));
var Operator;
(function (Operator) {
    Operator["ALL_APPLICABLE_OPERATORS"] = "ALL_APPLICABLE_OPERATORS";
    Operator["EQ"] = "EQ";
    Operator["GT"] = "GT";
    Operator["GTE"] = "GTE";
    Operator["IN"] = "IN";
    Operator["LT"] = "LT";
    Operator["LTE"] = "LTE";
    Operator["NE"] = "NE";
    Operator["NIN"] = "NIN";
    Operator["BEGINS"] = "BEGINS";
    Operator["EXISTS"] = "EXISTS";
    Operator["ALL"] = "ALL";
    Operator["ANY"] = "ANY";
})(Operator = exports.Operator || (exports.Operator = {}));
var OptimizeMode;
(function (OptimizeMode) {
    OptimizeMode["SPEED"] = "SPEED";
    OptimizeMode["CODE_SIZE"] = "CODE_SIZE";
    OptimizeMode["LITE_RUNTIME"] = "LITE_RUNTIME";
})(OptimizeMode = exports.OptimizeMode || (exports.OptimizeMode = {}));
var PagingType;
(function (PagingType) {
    PagingType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    PagingType["OFFSET"] = "OFFSET";
    PagingType["CURSOR"] = "CURSOR";
})(PagingType = exports.PagingType || (exports.PagingType = {}));
var ParticipantState;
(function (ParticipantState) {
    ParticipantState["JOIN_REQUESTED"] = "JOIN_REQUESTED";
    ParticipantState["INVITED"] = "INVITED";
    ParticipantState["JOIN_REJECTED"] = "JOIN_REJECTED";
    ParticipantState["PAYMENT_REQUESTED"] = "PAYMENT_REQUESTED";
    ParticipantState["PAYMENT_STARTED"] = "PAYMENT_STARTED";
    ParticipantState["JOINED"] = "JOINED";
    ParticipantState["LEFT"] = "LEFT";
    ParticipantState["REMOVED"] = "REMOVED";
    ParticipantState["RUNNING"] = "RUNNING";
    ParticipantState["COMPLETED"] = "COMPLETED";
    ParticipantState["FAILED"] = "FAILED";
    ParticipantState["PAYMENT_STARTED_OFFLINE"] = "PAYMENT_STARTED_OFFLINE";
})(ParticipantState = exports.ParticipantState || (exports.ParticipantState = {}));
var ParticipantStepState;
(function (ParticipantStepState) {
    ParticipantStepState["PENDING"] = "PENDING";
    ParticipantStepState["RUNNING"] = "RUNNING";
    ParticipantStepState["COMPLETED"] = "COMPLETED";
    ParticipantStepState["SKIPPED"] = "SKIPPED";
    ParticipantStepState["CONFIRMED"] = "CONFIRMED";
    ParticipantStepState["REJECTED"] = "REJECTED";
    ParticipantStepState["OVERDUE"] = "OVERDUE";
})(ParticipantStepState = exports.ParticipantStepState || (exports.ParticipantStepState = {}));
var ParticipantStepTransitionState;
(function (ParticipantStepTransitionState) {
    ParticipantStepTransitionState["Pending"] = "Pending";
    ParticipantStepTransitionState["Started"] = "Started";
    ParticipantStepTransitionState["Completed"] = "Completed";
    ParticipantStepTransitionState["Skipped"] = "Skipped";
    ParticipantStepTransitionState["Confirmed"] = "Confirmed";
    ParticipantStepTransitionState["Rejected"] = "Rejected";
    ParticipantStepTransitionState["Overdue"] = "Overdue";
})(ParticipantStepTransitionState = exports.ParticipantStepTransitionState || (exports.ParticipantStepTransitionState = {}));
var ParticipantStepUpdateStatus;
(function (ParticipantStepUpdateStatus) {
    ParticipantStepUpdateStatus["StepCompleted"] = "StepCompleted";
    ParticipantStepUpdateStatus["StepSkipped"] = "StepSkipped";
})(ParticipantStepUpdateStatus = exports.ParticipantStepUpdateStatus || (exports.ParticipantStepUpdateStatus = {}));
var ParticipantTransitionState;
(function (ParticipantTransitionState) {
    ParticipantTransitionState["JoinRequested"] = "JoinRequested";
    ParticipantTransitionState["Invited"] = "Invited";
    ParticipantTransitionState["JoinRejected"] = "JoinRejected";
    ParticipantTransitionState["PaymentRequested"] = "PaymentRequested";
    ParticipantTransitionState["PaymentStarted"] = "PaymentStarted";
    ParticipantTransitionState["Joined"] = "Joined";
    ParticipantTransitionState["Left"] = "Left";
    ParticipantTransitionState["Removed"] = "Removed";
    ParticipantTransitionState["Started"] = "Started";
    ParticipantTransitionState["Completed"] = "Completed";
    ParticipantTransitionState["Failed"] = "Failed";
})(ParticipantTransitionState = exports.ParticipantTransitionState || (exports.ParticipantTransitionState = {}));
var ParticipationState;
(function (ParticipationState) {
    ParticipationState["NotStarted"] = "NotStarted";
    ParticipationState["InProgress"] = "InProgress";
    ParticipationState["Finished"] = "Finished";
})(ParticipationState = exports.ParticipationState || (exports.ParticipationState = {}));
var PaymentType;
(function (PaymentType) {
    PaymentType["SINGLE_PAYMENT"] = "SINGLE_PAYMENT";
    PaymentType["PAID_PLANS"] = "PAID_PLANS";
})(PaymentType = exports.PaymentType || (exports.PaymentType = {}));
var PrivacyStatusStatus;
(function (PrivacyStatusStatus) {
    PrivacyStatusStatus["UNKNOWN"] = "UNKNOWN";
    PrivacyStatusStatus["PRIVATE"] = "PRIVATE";
    PrivacyStatusStatus["PUBLIC"] = "PUBLIC";
})(PrivacyStatusStatus = exports.PrivacyStatusStatus || (exports.PrivacyStatusStatus = {}));
var QueryParticipantsRequestSortingCriterion;
(function (QueryParticipantsRequestSortingCriterion) {
    QueryParticipantsRequestSortingCriterion["DEFAULT"] = "DEFAULT";
    QueryParticipantsRequestSortingCriterion["JOIN_DATE"] = "JOIN_DATE";
    QueryParticipantsRequestSortingCriterion["NAME"] = "NAME";
    QueryParticipantsRequestSortingCriterion["LAST_EVENT"] = "LAST_EVENT";
    QueryParticipantsRequestSortingCriterion["PERFORMANCE"] = "PERFORMANCE";
})(QueryParticipantsRequestSortingCriterion = exports.QueryParticipantsRequestSortingCriterion || (exports.QueryParticipantsRequestSortingCriterion = {}));
var QueryParticipantsRequestSortingOrder;
(function (QueryParticipantsRequestSortingOrder) {
    QueryParticipantsRequestSortingOrder["ORDER_DEFAULT"] = "ORDER_DEFAULT";
    QueryParticipantsRequestSortingOrder["ORDER_ASC"] = "ORDER_ASC";
    QueryParticipantsRequestSortingOrder["ORDER_DESC"] = "ORDER_DESC";
})(QueryParticipantsRequestSortingOrder = exports.QueryParticipantsRequestSortingOrder || (exports.QueryParticipantsRequestSortingOrder = {}));
var ResolutionStatus;
(function (ResolutionStatus) {
    ResolutionStatus["COMPLETED"] = "COMPLETED";
    ResolutionStatus["SKIPPED"] = "SKIPPED";
    ResolutionStatus["UNDO"] = "UNDO";
})(ResolutionStatus = exports.ResolutionStatus || (exports.ResolutionStatus = {}));
var Role;
(function (Role) {
    Role["UNDEFINED_ROLE"] = "UNDEFINED_ROLE";
    Role["MEMBER"] = "MEMBER";
    Role["OWNER"] = "OWNER";
    Role["CONTRIBUTOR"] = "CONTRIBUTOR";
})(Role = exports.Role || (exports.Role = {}));
var RuleType;
(function (RuleType) {
    RuleType["VALIDATION"] = "VALIDATION";
    RuleType["OTHER"] = "OTHER";
    RuleType["MAX"] = "MAX";
    RuleType["MIN"] = "MIN";
    RuleType["MAX_LENGTH"] = "MAX_LENGTH";
    RuleType["MIN_LENGTH"] = "MIN_LENGTH";
    RuleType["MAX_SIZE"] = "MAX_SIZE";
    RuleType["MIN_SIZE"] = "MIN_SIZE";
    RuleType["FORMAT"] = "FORMAT";
    RuleType["DECIMAL_LTE"] = "DECIMAL_LTE";
    RuleType["DECIMAL_GTE"] = "DECIMAL_GTE";
    RuleType["DECIMAL_LT"] = "DECIMAL_LT";
    RuleType["DECIMAL_GT"] = "DECIMAL_GT";
    RuleType["DECIMAL_MAX_SCALE"] = "DECIMAL_MAX_SCALE";
    RuleType["INVALID_ENUM_VALUE"] = "INVALID_ENUM_VALUE";
    RuleType["REQUIRED_FIELD"] = "REQUIRED_FIELD";
})(RuleType = exports.RuleType || (exports.RuleType = {}));
var SegmentSegment;
(function (SegmentSegment) {
    SegmentSegment["UNSPECIFIED"] = "UNSPECIFIED";
    SegmentSegment["USERS"] = "USERS";
    SegmentSegment["PUBLIC"] = "PUBLIC";
    SegmentSegment["OTHERS"] = "OTHERS";
})(SegmentSegment = exports.SegmentSegment || (exports.SegmentSegment = {}));
var ServiceAppendixType;
(function (ServiceAppendixType) {
    ServiceAppendixType["UNKNOWN_APPENDIX_TYPE"] = "UNKNOWN_APPENDIX_TYPE";
    ServiceAppendixType["NILE"] = "NILE";
    ServiceAppendixType["MESSAGE_BUS"] = "MESSAGE_BUS";
})(ServiceAppendixType = exports.ServiceAppendixType || (exports.ServiceAppendixType = {}));
var SettingsPricingSinglePaymentPaymentMethod;
(function (SettingsPricingSinglePaymentPaymentMethod) {
    SettingsPricingSinglePaymentPaymentMethod["OnlinePayment"] = "OnlinePayment";
    SettingsPricingSinglePaymentPaymentMethod["OfflinePayment"] = "OfflinePayment";
})(SettingsPricingSinglePaymentPaymentMethod = exports.SettingsPricingSinglePaymentPaymentMethod || (exports.SettingsPricingSinglePaymentPaymentMethod = {}));
var SiteMemberPrivacyStatus;
(function (SiteMemberPrivacyStatus) {
    SiteMemberPrivacyStatus["UNDEFINED"] = "UNDEFINED";
    SiteMemberPrivacyStatus["PUBLIC"] = "PUBLIC";
    SiteMemberPrivacyStatus["PRIVATE"] = "PRIVATE";
    SiteMemberPrivacyStatus["COMMUNITY"] = "COMMUNITY";
})(SiteMemberPrivacyStatus = exports.SiteMemberPrivacyStatus || (exports.SiteMemberPrivacyStatus = {}));
var SiteMemberStatus;
(function (SiteMemberStatus) {
    SiteMemberStatus["UNDEFINED_STATUS"] = "UNDEFINED_STATUS";
    SiteMemberStatus["APPLICANT"] = "APPLICANT";
    SiteMemberStatus["ACTIVE"] = "ACTIVE";
    SiteMemberStatus["INACTIVE"] = "INACTIVE";
    SiteMemberStatus["BLOCKED"] = "BLOCKED";
    SiteMemberStatus["OFFLINE_ONLY"] = "OFFLINE_ONLY";
})(SiteMemberStatus = exports.SiteMemberStatus || (exports.SiteMemberStatus = {}));
var Sort;
(function (Sort) {
    Sort["NONE"] = "NONE";
    Sort["ASC"] = "ASC";
    Sort["DESC"] = "DESC";
    Sort["BOTH"] = "BOTH";
})(Sort = exports.Sort || (exports.Sort = {}));
var SubjectType;
(function (SubjectType) {
    SubjectType["JoinRequest"] = "JoinRequest";
    SubjectType["JoinInvitation"] = "JoinInvitation";
    SubjectType["StepConfirmation"] = "StepConfirmation";
})(SubjectType = exports.SubjectType || (exports.SubjectType = {}));
var TranslatableType;
(function (TranslatableType) {
    TranslatableType["UNDEFINED_TYPE"] = "UNDEFINED_TYPE";
    TranslatableType["SHORT_TEXT"] = "SHORT_TEXT";
    TranslatableType["LONG_TEXT"] = "LONG_TEXT";
    TranslatableType["RICH_TEXT"] = "RICH_TEXT";
    TranslatableType["RICH_CONTENT_EDITOR"] = "RICH_CONTENT_EDITOR";
    TranslatableType["SELECTION"] = "SELECTION";
    TranslatableType["MULTI_SELECTION"] = "MULTI_SELECTION";
    TranslatableType["DOCUMENT"] = "DOCUMENT";
    TranslatableType["IMAGE"] = "IMAGE";
    TranslatableType["VIDEO"] = "VIDEO";
})(TranslatableType = exports.TranslatableType || (exports.TranslatableType = {}));
var Trigger;
(function (Trigger) {
    Trigger["JOINED_TO_CHALLENGE"] = "JOINED_TO_CHALLENGE";
    Trigger["STEP_COMPLETED"] = "STEP_COMPLETED";
    Trigger["ALL_STEPS_COMPLETED"] = "ALL_STEPS_COMPLETED";
})(Trigger = exports.Trigger || (exports.Trigger = {}));
var UserRole;
(function (UserRole) {
    UserRole["Owner"] = "Owner";
    UserRole["Participant"] = "Participant";
    UserRole["Outsider"] = "Outsider";
})(UserRole = exports.UserRole || (exports.UserRole = {}));
var V0AccessType;
(function (V0AccessType) {
    V0AccessType["Public"] = "Public";
    V0AccessType["Private"] = "Private";
    V0AccessType["Secret"] = "Secret";
})(V0AccessType = exports.V0AccessType || (exports.V0AccessType = {}));
var V0ChallengeState;
(function (V0ChallengeState) {
    V0ChallengeState["Draft"] = "Draft";
    V0ChallengeState["Published"] = "Published";
    V0ChallengeState["Finished"] = "Finished";
    V0ChallengeState["Archived"] = "Archived";
})(V0ChallengeState = exports.V0ChallengeState || (exports.V0ChallengeState = {}));
var V0DurationUnit;
(function (V0DurationUnit) {
    V0DurationUnit["Days"] = "Days";
    V0DurationUnit["Weeks"] = "Weeks";
})(V0DurationUnit = exports.V0DurationUnit || (exports.V0DurationUnit = {}));
var V1AccessType;
(function (V1AccessType) {
    V1AccessType["PUBLIC"] = "PUBLIC";
    V1AccessType["PRIVATE"] = "PRIVATE";
    V1AccessType["SECRET"] = "SECRET";
})(V1AccessType = exports.V1AccessType || (exports.V1AccessType = {}));
var V1ChallengeState;
(function (V1ChallengeState) {
    V1ChallengeState["DRAFT"] = "DRAFT";
    V1ChallengeState["PUBLISHED"] = "PUBLISHED";
    V1ChallengeState["FINISHED"] = "FINISHED";
    V1ChallengeState["ARCHIVED"] = "ARCHIVED";
})(V1ChallengeState = exports.V1ChallengeState || (exports.V1ChallengeState = {}));
var V1DurationUnit;
(function (V1DurationUnit) {
    V1DurationUnit["WEEKS"] = "WEEKS";
    V1DurationUnit["DAYS"] = "DAYS";
    V1DurationUnit["HOURS"] = "HOURS";
    V1DurationUnit["MINUTES"] = "MINUTES";
})(V1DurationUnit = exports.V1DurationUnit || (exports.V1DurationUnit = {}));
var ValidationStrategy;
(function (ValidationStrategy) {
    ValidationStrategy["FAIL_ON_ERRORS"] = "FAIL_ON_ERRORS";
    ValidationStrategy["FIX_ERRORS"] = "FIX_ERRORS";
})(ValidationStrategy = exports.ValidationStrategy || (exports.ValidationStrategy = {}));
var WinCriterion;
(function (WinCriterion) {
    WinCriterion["MinTime"] = "MinTime";
    WinCriterion["MaxSteps"] = "MaxSteps";
    WinCriterion["MaxMilestones"] = "MaxMilestones";
    WinCriterion["MaxPoints"] = "MaxPoints";
})(WinCriterion = exports.WinCriterion || (exports.WinCriterion = {}));
//# sourceMappingURL=types.js.map